import { render, staticRenderFns } from "./WarehouseClose.vue?vue&type=template&id=328d5798&scoped=true&"
import script from "./WarehouseClose.vue?vue&type=script&lang=js&"
export * from "./WarehouseClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d5798",
  null
  
)

export default component.exports